import { gql } from "graphql-tag"

const DELETE_OUTLET = gql`
  mutation deleteOutlet($id: ID!) {
    deleteOutlet(id: $id) {
      status
    }
  }
`

export default DELETE_OUTLET
